<div>
  <div class="price-container">
    <div class="side-price">
      <span>{{ "webPos.Price" | translate }}:</span>
      <span class="price-value"> {{ tripData.totalPrice | hcurrency : stateService.currencyCode() }}</span>
    </div>
    <div class="side-price border">
      <span *ngIf="!isReturn && amountToDisplay >= 0">{{ "webPos.LeftToPay" | translate }}:</span>
      <span *ngIf="!isReturn && amountToDisplay < 0">{{ "webPos.Overpayment" | translate }}:</span>
      <span *ngIf="isReturn">{{ "webPos.MaxReturnValue" | translate }}:</span>
      <span class="price-value"> {{ amountToDisplay | hcurrency : stateService.currencyCode() : true }} </span>
      
    </div>
    <div class="side-price border" *ngIf="isReturn">
      <span>{{ remainingToPayLabelKey | translate }}:</span>
      <span class="price-value"> {{ remainingToPay | hcurrency : stateService.currencyCode() }} </span>
    </div>
  </div>
</div>